<!-- Start Content-->
<div class="container-fluid">
    <div class="row my-1">
        <div class="col-md-12">
            <div class="userTables">

                <div class="row">
                    <div class="col-12">
                        <h2>Expose List</h2>
                        <div class="table-responsive">
                            <table class="table mb-0 table-bordered">
                                <thead>
                                    <tr>
                                        <th>Expose</th>
                                        <th>Event</th>
                                        <!-- <th>Runner Name</th> -->
                                        <th>market</th>
                                        <th>event id</th>
                                        <th>market name</th>
                                        <th>event type id</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="data && data.length > 0">
                                    <tr *ngFor="let item of data;let i=index; trackBy:trackByIndex;">
                                        <td [ngClass]="item?.dt?.expose > 0 ? 'text-green' : 'text-red'">{{item?.dt?.expose}}</td>
                                        <td><a herf="javascript:void(0);" [routerLink]="['/event/detail',item?.dt?.event_id]">{{item?.dt?.event_name}}</a></td>
                                        <!-- <td>{{item?.dt?.market_type_id == 'FANCY' ? item?.fancy_name : item?.runner_name}}</td> -->
                                        <td>{{item?.dt?.market_type_id}}</td>
                                        <td>{{item?.dt?.event_id}}</td>
                                        <td>{{displayMarketName(item?.dt)}}</td>
                                        <td>{{item?.dt?.event_type_id}}</td>
                                    </tr>
                                </tbody>
    
                                <tbody *ngIf="data && (!data || data?.length == 0)">
                                    <tr>
                                        <td colspan="10" class="noData"> {{env.noDataMsg}}</td>
                                    </tr>
                                </tbody>
    
                                <tbody *ngIf="!data">
                                    <tr>
                                        <td colspan="10">
                                            <app-loader class="no-overlay"></app-loader>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>